export default "<div class=\"app\">\n  <div class=\"app_children\" ng-transclude></div>\n</div>\n";